module.exports = __webpack_public_path__ + "static/spotify-b1b0200b7730b0f3f2cc851a7021bcef.png";